<template>
<div class="news-detail-main">
<el-container class="news-detail-main-container">
  <el-aside width="117px" class="left-content">
    
    
    <div style="position:relative;width:117px;height:100px;">
      <img src="../assets/news_bg_2.png">
      <div style="position:absolute;right:0px;bottom:8px;width:85px;">
          <p>{{date}}</p>
          <p>{{year}}</p>
      </div>
  </div>
  </el-aside>
  <el-container class="news-content">

    <el-main>
      <div class="news-detail-title">
          {{news.title}}
      </div>
      <div v-html="news.content" class="news-detail-content">
      </div>      
    </el-main>
  </el-container>

  <el-aside width="200px"  style="height:200px;" class="right-menu">
    <div class="main-title">&nbsp;&nbsp;&nbsp;相关新闻</div>
    <ul  style="list-style-type:square;color: blue;">
      <li v-for="item in related_news">
      <a :href="'#/website/news_detail?id='+item.id">{{item.ss_title}}</a>
      </li>

    </ul>
  </el-aside>
</el-container>
</div>
</template>
<style>
  .news-detail-content img{
    margin: 5px auto;
    display: block;
  }

  /*.fr-view img.fr-dib {
    margin: 5px auto;
    display: block;
    float: none;
    vertical-align: top;
}*/

  .news-detail-title {
    font-size: 24px;
    color:#333;
  }

  .left-content p {
    margin: 0px;
    font-size:27px;
    color:white;
  }
  .el-header {
    /*background-color: #B3C0D1;*/
    /*color: #333;*/
    line-height: 60px;
    margin:0 auto;
    
  }
  .right-menu li {
    border-bottom:solid 1px #d0dee5;
  }

  .right-menu a {
    text-decoration: none;color: #333;
  }
  .news-detail-main {
    /*text-align: center;*/
    margin-top: 40px;
    background-color: #FFFFFF;
  }

  .news-detail-main-container {
    margin:0 auto;
    width: 85%;
    padding-top: 60px;
  }

  .right-menu {
    /*background-color: white;*/
    border: 1px solid #83C0FB;
  }
  .main-title{
    border-left: solid 4px #409EFF;
    margin-top: 10px;
    margin-left: 20px;
  }
</style>

<script>
  import axios from 'axios';
  export default {
    name:"media",
    data() {
      const item = {
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄',
        img: require('../assets/news_bg.png')
      };
      return {
        tableData: Array(20).fill(item),
        activeIndex:"1",
        id:"",
        news: {
          id:"",
          title:"",
          content:"",
          date:""
        },
        year:"",
        date:"",
        related_news:[]
      }
    },
    mounted(){
      var id = this.$route.query.id||"";
      this.id = id;
      axios.get(this.base+`/rest/account/api/news`, {params:{id:this.id}}).then(res => {
            if (res.data.code == 200) {
              this.news = res.data.data.news;
              var date_list = this.news.date.split("-");
              this.year = date_list[0];
              this.date = date_list[1]+"."+ date_list[2];
            }
          });

      axios.get(this.base+`/rest/account/api/related_news`, {params:{id:this.id}}).then(res => {
            if (res.data.code == 200) {
              this.related_news = res.data.data.items;
            }
          });
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/NewsDetail.vue